import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import FounderRoomForm from 'components/views/FounderRooms/_components/FounderRoomForm';
import { handleSubmitUpdateRoom } from 'components/views/FounderRoom/_helpers/founderRoom.events';
import { $form, $view } from 'signals/global.signals';

const FounderRoomEditModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'room-edit'}
    title={`Edit Room - ${$form.value.name} - ${$form.value.dealName}`}
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitUpdateRoom}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <FounderRoomForm mode="edit" />
  </SimpleModal>

);

export default FounderRoomEditModal;
